// routes
import { Icon } from '@iconify/react';
import { PATH_DASHBOARD } from '../../../routes/paths';



const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------

  {
    items: [
      { title: 'Profile', path: PATH_DASHBOARD.magictype.magictype, icon: <Icon icon="pajamas:profile" /> },
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'View Users', path: PATH_DASHBOARD.element.element, icon: <Icon icon="fa6-brands:elementor" /> },
      { title: 'Manage Admin', path: PATH_DASHBOARD.dorm.dorm, icon: <Icon icon="fontisto:world" /> },
    ],
  },

  {
    items: [
      { title: 'Profile', path: PATH_DASHBOARD.magictype.magictype, icon: <Icon icon="pajamas:profile" /> },
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'View Users', path: PATH_DASHBOARD.element.element, icon: <Icon icon="fa6-brands:elementor" /> },
    ],
  },

];

export default navConfig;
